export const formatCurrency = (num: number) => {
    if (Number.isInteger(num)) {
        return `$${num.toLocaleString('en-US', { minimumFractionDigits: 0 })}`;
    } else {
        return `$${num.toLocaleString('en-US', { minimumFractionDigits: 2 })}`;
    }
};
